<template>
  <mobile-header
    v-if="showHeader"
    :goback="goBack"
    ref="header"
    customBackgroundColor="#fbfbfb"
    borderBottom="1px solid #fbfbfb"
    customColor="#333"
    :opt-txt="optTxt"
    optBtn="true"
    :customOpt="headLeftOpt"
    alwaysShow="true"
    pageWidth="true"
    class="expert-list-header"
    :isCustomText="`<a href='https://m.xinli001.com/consult' style='text-align: center;'><i style='font-size: .42667rem;' class='icon-node-website icon-weibiaoti--'></i></a>`"
    @initDone="$emit('initDone')"
  >
    <div class="header-slot">
      <!--<span class="yxl-font yxl-font-search"></span>-->
      <icon name="search" />
      <div
        class="header-search"
        placeholder="搜索咨询师或问题类型"
        v-stat="'搜索'"
        @click="linkToSearch"
      >
        搜索咨询师或问题类型
      </div>
    </div>
    <template slot="optBtnRight">
      <div
        class="each-icon"
        v-for="(icon, index) in icons"
        :key="index"
        @click="toPage(index)"
      >
        <img :src="icon.icon" alt="" class="icon-img" />
        <div class="icon-name">{{ icon.name }}</div>
      </div>
      <!-- <icon name="zhinengzhuli" @click="$emit('toAI')" class="top_icon" /> -->
    </template>
  </mobile-header>
</template>

<script>
import MobileHeader from 'component/consult/mobileHeader.vue'
import { versionfunegt } from 'lib/tools/utils.js'
export default {
  components: {
    MobileHeader
  },
  data() {
    return {
      icons: [
        {
          name: '咨询指南',
          icon: require('images/consult/expertList/guide-icon.png')
        },
        {
          name: '智能助理',
          icon: require('images/consult/expertList/icon-aid.png')
        }
      ]
    }
  },
  methods: {
    goBack() {
      event && event.preventDefault()
      this.$platform.isYixinliApp || this.$platform.isZiXunApp
        ? this.$bridge.cancelWebView()
        : this.$router.replace({
            path: '/consult'
          })
    },
    linkToSearch() {
      if (this.$platform.isYixinliApp || this.$platform.isZiXunApp) {
        this.$bridge.gotoSearchPage({ from: 'zixun' })
      } else {
        this.routerPush(`https://static.xinli001.com/msite/index.html#/search`)
      }
    },
    toPage(i) {
      if (i == 0) {
        this.routerPush('/consult/guide')
      } else if (i == 1) {
        this.$emit('toAI')
      }
    }
  },
  computed: {
    optTxt() {
      return `<span>订单</span>`
    },
    headLeftOpt() {
      let opt = this.channelId
        ? [
            {
              icon: 'privateletter',
              method: () => this.linkToPage('sixin')
            }
          ]
        : [
            {
              icon: 'weibiaoti--',
              method: () => {
                this.goBack()
              }
            }
          ]
      return opt
    },
    showHeader() {
      if (
        this.mixinIsApp &&
        !versionfunegt(this.$route.query._version, '5.9.0')
      ) {
        return false
      } else if (this.isWebviewMp) {
        return false
      } else {
        return +this.$route.query.showHeader !== 0
      }
    }
  }
}
</script>

<style lang="scss">
.expert-list-header {
  position: relative;
  z-index: 3;
  .header-right {
    .icon-zhinengzhuli {
      font-size: 60px;
    }
  }
  .header-slot {
    // width: 464px;
    height: 60px !important;
    border-radius: 100px;
    background-color: #ececec !important;
    display: flex;
    padding-left: 36px;
    box-sizing: border-box !important;
    align-items: center;
    overflow: hidden;
    margin-left: 16px;
    margin-right: 26px;

    .header-search {
      background-color: #ececec;
      font-size: 24px;
      height: 60px;
      line-height: 60px;
      box-sizing: border-box;
      margin-left: 26px;
      flex: 1;
      color: #9da3ac;
    }
    input::-webkit-input-placeholder {
      color: #9da3ac !important;
    }
    input:-moz-placeholder {
      color: #9da3ac !important;
    }
    .icon-search {
      color: #9da3ac;
      font-size: 32px;
    }
  }
  .each-icon {
    display: inline-block;
    &:nth-child(2) {
      margin-left: 30px;
    }
    .icon-img {
      width: 30px;
      height: 36px;
      margin: 0 auto;
    }
    .icon-name {
      font-size: 18px;
      color: #333;
    }
  }
}
</style>
